// extracted by mini-css-extract-plugin
export var button = "linkButton-module--button--2dlNE";